var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-zip';
                    var viewUrl = 'gfx/sprite.svg#view-icon-zip';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };